import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'nimbus-form-control',
  templateUrl: './form-control.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'nimbus-form-control control-size-normal',
  },
})
export class FormControlComponent {
  @Input()
  @HostBinding('class.flex-form-control')
  public isFlex: boolean = false;
}
